import type { ReactNode } from "react";
import { twMerge } from "tailwind-merge";

type LayoutProps = {
  children: ReactNode;
  className?: string;
};

export const Layout = ({ children, className }: LayoutProps) => {
  // Deviation from VD: keep a base `px-4` gutter. GAO uses Layout as the primary
  // page container (10+ pages), so without it cards touch the screen edge on mobile.
  return <div className={twMerge("mx-auto max-w-6xl px-4 pt-8 pb-20 2xl:px-8", className)}>{children}</div>;
};
